export const PRICE_LIST_CATEGORY = 'Price lists'
